// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"180":"App","475":"views"}[chunkId] || chunkId) + "." + {"180":"674fe347","475":"5975d756","480":"93776e1c"}[chunkId] + ".chunk.css";
};